import {
  Modal,
  useSession,
  useTranslation,
  ButtonAlignment,
  ButtonSize,
  ButtonStyles,
  Button,
} from '@nextgen-web-framework/all';
import { CartEntryDetails, SopElementResponse, hideBV } from '@commerce-cart-webcomponents/sdk';
import { CheckoutCard } from '@commerce-product-webcomponents/ui';
import { CheckoutCardForModal } from '../../../common/components/checkout-card-for-modal/CheckoutCardForModal';
import styles from '../expiry-modal/ExpiryModal.module.scss';

export type ItemsUnavailableProps = {
  notAvailableEntries: CartEntryDetails[];
  showRemoveSOPItemsModal?: boolean;
  allSOPEntries?: SopElementResponse[];
  sopHeadingText?: string;
  isCompensatedModal?: boolean;
  onPrimaryBtnClick?: () => void;
  onSecondaryBtnClick?: () => void;
};

export const ItemsUnavailable = ({
  notAvailableEntries,
  showRemoveSOPItemsModal,
  allSOPEntries,
  sopHeadingText,
  isCompensatedModal,
  onPrimaryBtnClick,
  onSecondaryBtnClick,
}: ItemsUnavailableProps) => {
  const t = useTranslation();
  const { isABO } = useSession();
  const reviewCartText = t('cart.itemsUnavailable.reviewCart');
  const headLineText = showRemoveSOPItemsModal
    ? t('cart.itemsUnavailable.removeSOPitems')
    : t('cart.itemsUnavailable.itemsUnavailable');
  const headingText = showRemoveSOPItemsModal ? sopHeadingText : t('cart.itemsUnavailable.itemsCurrentlyUnavailable');

  const showButton = (title: string, buttonStyle: ButtonStyles, onButtonClick?: () => void) => (
    <Button
      title={title}
      buttonStyle={buttonStyle}
      size={ButtonSize.MEDIUM}
      data-testid={`button-${title}`}
      aria-label={title}
      onClick={onButtonClick}
    />
  );

  return (
    <Modal
      buttonAlignment={ButtonAlignment.VERTICAL}
      closeIcon={false}
      primaryButtonLabel={''}
      headline={isCompensatedModal ? t('cart.itemsUnavailable.removeSOP') : headLineText}
    >
      <>
        {isCompensatedModal && (
          <div className={styles['expiry-modal-container-heading']}>
            {t('cart.itemsUnavailable.compensatedOrderRemove')}
          </div>
        )}

        {!isCompensatedModal && (
          <div className={styles['expiry-modal-container']}>
            <div className={styles['expiry-modal-container-heading']}>{headingText}</div>

            {showRemoveSOPItemsModal
              ? allSOPEntries &&
                allSOPEntries.map((sopElement: SopElementResponse) => {
                  const { totalPrice, planName, images, totalPriceWithoutDiscount } = sopElement;
                  const { pointValue, businessVolume } = totalPrice?.amwayValue ?? {};
                  return (
                    <CheckoutCard
                      key={sopElement.sopId}
                      className={styles['checkout-card-component']}
                      pointValue={isABO() ? String(pointValue) : ''}
                      businessVolume={isABO() && !hideBV() ? String(businessVolume) : ''}
                      currency={totalPrice?.currency}
                      productPrice={totalPrice?.value}
                      productSize=""
                      productId=""
                      productName={planName as string}
                      link={images?.[0]?.imageUrl as string}
                      alt={images?.[0]?.altText as string}
                      brandName={planName as string}
                      strikethroughPrice={totalPriceWithoutDiscount?.value}
                    />
                  );
                })
              : notAvailableEntries?.map((entry) =>
                  CheckoutCardForModal({
                    entry,
                    isABO: isABO(),
                    className: styles['checkout-card-component'],
                  }),
                )}
          </div>
        )}

        <div className={styles['merge-expiry-button-container']}>
          {showButton(
            isCompensatedModal ? t('cart.cartLineItemErrorMsgs.remove') : reviewCartText,
            ButtonStyles.SOLID,
            onPrimaryBtnClick,
          )}
          {isCompensatedModal &&
            showButton(t('cart.clearCart.secondaryButton'), ButtonStyles.OUTLINE, onSecondaryBtnClick)}
        </div>
      </>
    </Modal>
  );
};
